import { render, staticRenderFns } from "./ExternalOrdersNo.vue?vue&type=template&id=64fbd020&scoped=true&"
import script from "./ExternalOrdersNo.vue?vue&type=script&lang=js&"
export * from "./ExternalOrdersNo.vue?vue&type=script&lang=js&"
import style0 from "./ExternalOrdersNo.vue?vue&type=style&index=0&id=64fbd020&lang=scss&scoped=true&"
import style1 from "./ExternalOrdersNo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbd020",
  null
  
)

export default component.exports